import React from 'react';

import CommercialTransactionList from './components/CommercialTransactionList';

/**
 * Payments Management function Component
 * @returns {React.JSX.Element} The rendered component.
 */
function EMSPTransactionManagement(): JSX.Element {
  return (
    <div>
      <CommercialTransactionList />
    </div>
  );
}

export default EMSPTransactionManagement;
